"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var country_hook_1 = require("../../../../context/CountryContext/country.hook");
var org_hook_1 = require("../../../../context/OrgContext/org.hook");
var general_1 = require("../../../../lib/general");
var icons_1 = __importDefault(require("../../../../theme/icons"));
require("../Style/style.scss");
function QuestionTable(props) {
    var header = [
        "question",
        "exam_type",
        "sorting_order",
        "data_type",
        "audio",
        "edit",
        "delete",
    ], _a = (0, react_i18next_1.useTranslation)(), t = _a.t, i18n = _a.i18n, currentLang = i18n.language, _b = (0, react_1.useState)([]), tableFields = _b[0], setTableFields = _b[1];
    var organization = (0, org_hook_1.useOrg)().organization;
    var country = (0, country_hook_1.useCountry)().country;
    (0, react_1.useEffect)(function () {
        setTableFields(props.list);
    }, [props.list]);
    var renderTableHeader = function () {
        return header.map(function (item, key) { return (react_1.default.createElement("th", { className: "cell", key: key, style: {
                backgroundColor: "#009CFF",
                color: "white",
            } }, t(item))); });
    }, renderBody = function () { return (react_1.default.createElement(react_1.default.Fragment, null, tableFields === null || tableFields === void 0 ? void 0 : tableFields.map(function (l, i) { return (react_1.default.createElement(react_1.Fragment, { key: i },
        react_1.default.createElement(react_1.default.Fragment, null, detailInfo(l)))); }))); };
    var detailInfo = function (item) {
        var _a, _b;
        var audio_link = (0, general_1.generateMediaLink)((0, general_1.isJsonWithAvailableLang)(item === null || item === void 0 ? void 0 : item.audio_link, currentLang, t), organization === null || organization === void 0 ? void 0 : organization.id, country);
        return (react_1.default.createElement("tr", null,
            react_1.default.createElement("td", { colSpan: 1, className: "cell", "data-title": "title", style: {
                    textAlign: "left",
                } }, (0, general_1.isJsonWithAvailableLang)(item.question, currentLang.toLowerCase(), t)),
            react_1.default.createElement("td", { className: "cell", "data-title": "exam_type" }, (0, general_1.isJsonWithAvailableLang)((_a = item.exam_type) === null || _a === void 0 ? void 0 : _a.name, currentLang.toLowerCase(), t)),
            react_1.default.createElement("td", { className: "cell", "data-title": "sorting_order" }, item.order_by),
            react_1.default.createElement("td", { className: "cell", "data-title": "data_type" }, (0, general_1.isJsonWithAvailableLang)((_b = item.data_type) === null || _b === void 0 ? void 0 : _b.name, currentLang.toLowerCase(), t)),
            react_1.default.createElement("td", { className: "cell", "data-title": "audio_link" }, audio_link !== null ? (react_1.default.createElement("audio", { id: "audio", controls: true },
                react_1.default.createElement("source", { src: audio_link, type: "audio/mpeg" }))) : ("")),
            react_1.default.createElement("td", { className: "cell", "data-title": "edit", onClick: function () { return props.onQuestionedit(item); } },
                react_1.default.createElement(icons_1.default, { name: "edit", height: 30, width: 30, className: "icon_black" })),
            react_1.default.createElement("td", { className: "cell", "data-title": "delete", onClick: function () { return props.onQuestiondelete(item); } },
                react_1.default.createElement(icons_1.default, { name: "delete", height: 30, width: 30, className: "icon_black" }))));
    };
    return (react_1.default.createElement("div", { className: "tableListContainer" },
        react_1.default.createElement("div", null,
            react_1.default.createElement("table", { className: "tableView" },
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null, renderTableHeader())),
                react_1.default.createElement("tbody", null, renderBody())))));
}
exports.default = QuestionTable;
